import React, { Component } from "react";

class Faq extends Component {
  state = {
    links: [
      {
        id: "0",
        name: "Jaime Enrique",
        target: "https://freesound.org/people/jaime_enrique/",
        label: "MUSIC:",
      },
      {
        id: "1",
        name: "Felix Blume",
        target: "https://felixblume.com/",
        label: "MUSIC:",
      },
      {
        id: "2",
        name: "All images are for educational purposes only.",
        target: "",
        label: "Furniture images:",
      },
    ],
  };

  render() {
    return (
      <>
        <section id="faq">
          <div className="faq__wrapper">
            <div className="faq__container">
              <h1>3D DESIGNER &#x26; DEVELOPER </h1>
              <h2>LAST UPDATED: AUGUST 2021</h2>
              <h3>info@volkanuve.com</h3>

              <h4>LEGALS</h4>

              <p>
                {" "}
                You may not copy, reproduce, republish, disassemble, decompile,
                reverse engineer, download, post, broadcast, transmit, make
                available to the public, or otherwise use www.volkanuve.com
                content in any way except for your own personal, non-commercial
                use. You also agree not to adapt, alter or create a derivative
                work from any www.volkanuve.com content except for your own
                personal, non-commercial use. Any other use of  www.volkanuve.com
                content requires the prior written permission of Volkanuve.
              </p>

              <p>
                {" "}
                THE AUTHOR ASSUMES NO LIABILITY FOR THE CONTENT OF EXTERNAL
                LINKS AND WEBSITES
              </p>

              <h4>CREDITS</h4>

              <div className="container_Links_Faq">
                <ul>
                  {this.state.links.map((itemLink) => (
                    <li key={itemLink.id}>
                      <a
                        href={itemLink.target}
                        rel="noopener noreferrer"
                        target="_blank"
                      >
                        <span>{itemLink.label}</span> {itemLink.name}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>

              <h5>DESIGN &#x26; CODE: Volkanuve </h5>
            </div>
          </div>
        </section>
      </>
    );
  }
}

export default Faq;
